<template>
  <div
    id="messages-column"
    class=" SB-border left">
    <template v-if="!activeConversation || !activeConversation.id || newConversationActive || firstConversationsPageLoading">
      <div class="start-conversation-placeholder flex center-all">
        <p>💬</p>
      </div>
    </template>
    <template v-else>
      <template v-if="!showEmptyDone && !showEmptyOpen">
        <MessagesHeader v-show="conversationSelected && activeConversation && activeConversation.id && !activeConversation.id.startsWith('TEMP-conversation')"/>
        <MessagesContactPreview v-if="conversationSelected && activeConversation && activeConversation.id && activeConversation.id.startsWith('TEMP-conversation')"/>
        <MessageList v-show="conversationSelected && activeConversation && activeConversation.id && !activeConversation.id.startsWith('TEMP-conversation')" />
        <MessagesFooter v-show="conversationSelected && activeConversation && activeConversation.id && !activeConversation.id.startsWith('TEMP-conversation')"/>
        <DropHere v-show="conversationSelected && activeConversation && activeConversation.id && !activeConversation.id.startsWith('TEMP-conversation')" />
        <PasteImageModal
          v-show="conversationSelected && activeConversation && activeConversation.id && !activeConversation.id.startsWith('TEMP-conversation')"
          ref="pasteImageModalRef" />
      </template>
      <DoneEmpty
        v-if="!forceConversationLoadSpinner && showEmptyDone && conversationsLoad.loaded" />
      <OpenEmpty
        v-if="!forceConversationLoadSpinner && showEmptyOpen && conversationsLoad.loaded" />
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import DropHere from '@/components/common/DropHere';
import MessageList from './partials/MessageList';
import MessagesContactPreview from './partials/MessagesContactPreview';
import DoneEmpty from './partials/DoneEmpty';
import OpenEmpty from './partials/OpenEmpty';
import MessagesFooter from './MessagesFooter';
import MessagesHeader from './MessagesHeader';
import PasteImageModal from '../notifications/modals/PasteImageModal';

export default {
  name: 'Messages',
  components: {
    DropHere,
    MessageList,
    MessagesFooter,
    MessagesHeader,
    PasteImageModal,
    MessagesContactPreview,
    DoneEmpty,
    OpenEmpty,
  },
  data() {
    return {
      newConversationActive: false,
    };
  },
  computed: {
    ...mapGetters({
      activeConversation: 'chat/activeConversation',
      templateMessageList: 'notification/templateMessageList',
      showEmptyDone: 'chat/showEmptyDone',
      showEmptyOpen: 'chat/showEmptyOpen',
      conversationsLoad: 'chat/conversationsLoad',
      forceConversationLoadSpinner: 'chat/forceConversationLoadSpinner',
    }),
    conversationSelected() {
      return this.activeConversation && !this.emptyObject(this.activeConversation);
    },
    firstConversationsPageLoading() {
      return !this.conversationsLoad.loaded && this.conversationsLoad.page === 1;
    },
  },
  watch: {
    // activeConversation() {
      // Decided not to go this route but leaving it here until the rewrite just in case we notice this is the better option.
      // ------------------------------------------------------------------------------------------------------------------------
      // if (this.activeConversation && this.activeConversation.id && this.activeConversation.id.startsWith('TEMP')) {
      //   const name = this.activeConversation.name ? this.activeConversation.name : this.activeConversation.phone;
      //   if (this.hasApprovedTemplateMessages()) {
      //     const name = this.activeConversation.name ? this.activeConversation.name : this.activeConversation.phone;
      //     this.$eventBus.$emit('show-notification-modal', {
      //       phone: name,
      //       businessId: this.activeConversation.businessId,
      //       templateMessageList: { ...this.templateMessageList },
      //     });
      //   } else {
      //     this.$eventBus.$emit('show-template-missing-modal', name);
      //   }
      // } else {
      //   this.$eventBus.$emit('close-template-missing-modal');
      // }
    // },
  },
  created() {},
  mounted() {
    this.$eventBus.$on('show-contact-search-view', this.showContactSearchView);
    this.$eventBus.$on('close-new-conversation-bar', this.closeNewConversationBar);
    this.$eventBus.$on('enable-new-message', this.closeNewConversationBar);
  },
  beforeDestroy() {},
  methods: {
    /** Checks if there is at least one approved template message. */
    hasApprovedTemplateMessages() {
      let hasApprovedTemplates = false;
      if (this.templateMessageList && this.templateMessageList.data.some(templateLang => templateLang.status === 'approved')) {
        hasApprovedTemplates = true;
      }
      return hasApprovedTemplates;
    },
    showContactSearchView() {
      this.newConversationActive = true;
    },
    closeNewConversationBar() {
      this.newConversationActive = false;
    },
  },
};
</script>

<style lang="scss" scoped>
#messages-column {
  flex-grow: 2;
  display: flex;
  flex-direction: column;
  background-color: $white;
  position: relative;
  min-width: 320px;

  .start-conversation-placeholder {
    height: 100%;
    font-size: 40px;
    opacity: 0.5;
  }
}
</style>
